export default "__VITE_ASSET__8n4YwnKo__"